import React, { useState, useEffect } from 'react'
import TopBar from '../../../components/TopBar'
import styles from './tool.module.css'
import { getOption, updateOption } from '../../../api/optionsApi'

const Tool = () => {
  const [premiumMilestone, setPremiumMilestone] = useState('')
  const [billFromData, setBillFromData] = useState({
    companyName: '',
    address: '',
    email: '',
    contactNumber: '',
    gstNumber: ''
  })
  const [isLoading, setIsLoading] = useState(false)
  const [isFetching, setIsFetching] = useState(true)
  const [error, setError] = useState({})
  const [saveSuccess, setSaveSuccess] = useState(false)

  // Default values for billFrom
  const DEFAULT_BILL_FROM = {
    companyName: 'Malmart',
    address: 'H.No: #6-1-344/8/1, 1st Floor, Street no 1\nPadmarao Nagar\nSecunderabad, TS, 500001, India',
    email: 'MalmartHyd@gmail.com',
    contactNumber: '+91XXXXXXXXXX',
    gstNumber: '36AATCM2163N1ZT'
  }

  useEffect(() => {
    const fetchToolSettings = async () => {
      try {
        const [toolData, billFromDataResponse] = await Promise.all([
          getOption('tool'),
          getOption('billFrom')
        ])

        // Load premium milestone
        const premiumValue = toolData?.data?.value?.premiumMilestone
        if (premiumValue !== undefined && premiumValue !== null) {
          setPremiumMilestone(String(premiumValue))
        }

        // Load billFrom data
        const billFromValue = billFromDataResponse?.data?.value
        if (billFromValue) {
          setBillFromData(billFromValue)
        } else {
          // Set default values if not available
          setBillFromData(DEFAULT_BILL_FROM)
        }
      } catch (error) {
        console.error('Failed to load tool settings:', error)
        // Set default billFrom values on error
        setBillFromData(DEFAULT_BILL_FROM)
      } finally {
        setIsFetching(false)
      }
    }
    fetchToolSettings()
  }, [])

  // Validation functions
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailRegex.test(email)
  }

  const validateContactNumber = (number) => {
    // Allow +91 followed by 10 digits, or just 10 digits
    const phoneRegex = /^(\+91)?[6-9]\d{9}$/
    return phoneRegex.test(number.replace(/\s/g, ''))
  }

  const validateGSTNumber = (gst) => {
    // GST format: 2 digit state code + 10 digit PAN + 1 digit entity + 1 digit check digit
    const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/
    return gstRegex.test(gst.toUpperCase())
  }

  const validatePremiumInput = () => {
    // if (premiumMilestone === '' || premiumMilestone === null) {
    //   setError(prev => ({ ...prev, premiumMilestone: 'Premium customer milestone is required' }))
    //   return false
    // }
    const numValue = Number(premiumMilestone)
    if (isNaN(numValue) || numValue < 0) {
      setError(prev => ({ ...prev, premiumMilestone: 'Please enter a valid positive number' }))
      return false
    }
    if (!Number.isInteger(numValue)) {
      setError(prev => ({ ...prev, premiumMilestone: 'Please enter a whole number' }))
      return false
    }
    return true
  }

  const validateBillFromData = () => {
    const newErrors = {}

    // Company name validation
    if (!billFromData.companyName.trim()) {
      newErrors.companyName = 'Company name is required'
    }

    // Address validation
    if (!billFromData.address.trim()) {
      newErrors.address = 'Address is required'
    }

    // Email validation
    if (!billFromData.email.trim()) {
      newErrors.email = 'Email is required'
    } else if (!validateEmail(billFromData.email)) {
      newErrors.email = 'Please enter a valid email address'
    }

    // Contact number validation
    if (!billFromData.contactNumber.trim()) {
      newErrors.contactNumber = 'Contact number is required'
    } else if (!validateContactNumber(billFromData.contactNumber)) {
      newErrors.contactNumber = 'Please enter a valid 10-digit Indian phone number'
    }

    // GST number validation
    if (!billFromData.gstNumber.trim()) {
      newErrors.gstNumber = 'GST number is required'
    } else if (!validateGSTNumber(billFromData.gstNumber)) {
      newErrors.gstNumber = 'Please enter a valid GST number'
    }

    setError(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleSave = async () => {
    const isPremiumValid = validatePremiumInput()
    const isBillFromValid = validateBillFromData()

    if (!isPremiumValid || !isBillFromValid) return

    setIsLoading(true)
    // setSaveSuccess(false)
    console.log({first:"call"})
    try {
      // Save both premium milestone and billFrom data
      await Promise.all([
        updateOption('tool', {
          premiumMilestone: Number(premiumMilestone)
        }),
        updateOption('billFrom', billFromData)
      ])

      // setSaveSuccess(true)
      // setTimeout(() => setSaveSuccess(false), 2500)
    } catch (error) {
      console.error('Failed to save tool settings:', error)
      setError(prev => ({ ...prev, general: 'Failed to save. Please try again.' }))
    } finally {
      setIsLoading(false)
    }
  }

  const handlePremiumMilestoneChange = (e) => {
    const value = e.target.value
    if (value === '' || /^\d+$/.test(value)) {
      setPremiumMilestone(value)
      if (error.premiumMilestone) {
        setError(prev => ({ ...prev, premiumMilestone: '' }))
      }
      if (saveSuccess) setSaveSuccess(false)
    }
  }

  const handleBillFromChange = (field, value) => {
    setBillFromData(prev => ({
      ...prev,
      [field]: value
    }))
    if (error[field]) {
      setError(prev => ({ ...prev, [field]: '' }))
    }
    if (saveSuccess) setSaveSuccess(false)
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && e.ctrlKey) {
      e.preventDefault()
      handleSave()
    }
  }

  return (
    <>
      <TopBar />
      <div className={styles.toolContainer}>
        <div className={styles.toolContent}>
          <div className={styles.toolHeader}>
            <h2 className={styles.toolTitle}>Tool Settings</h2>
          </div>

          {isFetching ? (
            <div style={{ padding: '40px 0', textAlign: 'center' }}>
              <div className='ringLoader'></div>
            </div>
          ) : (
            <>
              <p className={styles.toolDescription}>
                Configure your store tools and premium customer thresholds
              </p>

              {/* Premium Milestone Section */}
              <div className={styles.formGroup}>
                <label htmlFor="premiumMilestone">Milestone</label>
                <div>
                  <div className={styles.inputWrapper}>
                    <span className={styles.currencyPrefix}>₹</span>
                    <input
                      id="premiumMilestone"
                      type="number"
                      className={`${styles.numberInput} ${error.premiumMilestone ? styles.inputError : ''}`}
                      placeholder="e.g. 1000"
                      value={premiumMilestone}
                      onChange={handlePremiumMilestoneChange}
                      onKeyDown={handleKeyDown}
                      min="0"
                      step="1"
                      disabled={isLoading}
                    />
                  </div>
                  <p className={styles.helpText}>
                    Set the purchase milestone that upgrades customers to
                    <strong> Premium Customer</strong> status.
                  </p>
                </div>
                {error.premiumMilestone && (
                  <p className={styles.errorText}>{error.premiumMilestone}</p>
                )}
              </div>

              {/* Bill From Section */}
              <div className={styles.billSection} style={{ marginTop: '30px', borderTop: '1px solid #e5e7eb', paddingTop: '20px' }}>
                <h3 style={{ marginBottom: '15px', fontSize: '14px', fontWeight: '600', textAlign: 'left' }}>
                  Bill From Details
                </h3>

                {/* Company Name */}
                <div className={styles.formGroup}>
                  <label htmlFor="companyName">Company Name</label>
                  <div>
                    <input
                      id="companyName"
                      type="text"
                      className={`${styles.numberInput} ${error.companyName ? styles.inputError : ''}`}
                      placeholder="e.g. Malmart"
                      value={billFromData.companyName}
                      onChange={(e) => handleBillFromChange('companyName', e.target.value)}
                      disabled={isLoading}
                    />
                    {error.companyName && (
                      <p className={styles.errorText}>{error.companyName}</p>
                    )}
                  </div>
                </div>

                {/* Address */}
                <div className={styles.formGroup}>
                  <label htmlFor="address">Address</label>
                  <div>
                    <textarea
                      id="address"
                      className={`${styles.numberInput} ${error.address ? styles.inputError : ''}`}
                      placeholder="e.g. H.No: #6-1-344/8/1, 1st Floor&#10;Street no 1&#10;Padmarao Nagar&#10;Secunderabad, TS, 500001, India"
                      value={billFromData.address}
                      onChange={(e) => handleBillFromChange('address', e.target.value)}
                      disabled={isLoading}
                      rows="4"
                      style={{ fontFamily: 'inherit', resize: 'vertical' }}
                    />
                    {error.address && (
                      <p className={styles.errorText}>{error.address}</p>
                    )}
                  </div>
                </div>

                {/* Email */}
                <div className={styles.formGroup}>
                  <label htmlFor="email">Email</label>
                  <div>
                    <input
                      id="email"
                      type="email"
                      className={`${styles.numberInput} ${error.email ? styles.inputError : ''}`}
                      placeholder="e.g. MalmartHyd@gmail.com"
                      value={billFromData.email}
                      onChange={(e) => handleBillFromChange('email', e.target.value)}
                      disabled={isLoading}
                    />
                    {error.email && (
                      <p className={styles.errorText}>{error.email}</p>
                    )}
                  </div>
                </div>

                {/* Contact Number */}
                <div className={styles.formGroup}>
                  <label htmlFor="contactNumber">Contact Number</label>
                  <div>
                    <input
                      id="contactNumber"
                      type="tel"
                      className={`${styles.numberInput} ${error.contactNumber ? styles.inputError : ''}`}
                      placeholder="e.g. +91 9876543210 or 9876543210"
                      value={billFromData.contactNumber}
                      onChange={(e) => handleBillFromChange('contactNumber', e.target.value)}
                      disabled={isLoading}
                    />
                    {error.contactNumber && (
                      <p className={styles.errorText}>{error.contactNumber}</p>
                    )}
                  </div>
                </div>

                {/* GST Number */}
                <div className={styles.formGroup}>
                  <label htmlFor="gstNumber">GST Number</label>
                  <div>
                    <input
                      id="gstNumber"
                      type="text"
                      className={`${styles.numberInput} ${error.gstNumber ? styles.inputError : ''}`}
                      placeholder="e.g. 36AATCM2163N1ZT"
                      value={billFromData.gstNumber}
                      onChange={(e) => handleBillFromChange('gstNumber', e.target.value.toUpperCase())}
                      disabled={isLoading}
                      maxLength="15"
                    />
                    {error.gstNumber && (
                      <p className={styles.errorText}>{error.gstNumber}</p>
                    )}
                  </div>
                </div>
              </div>

              {/* General Error */}
              {error.general && (
                <p className={styles.errorText}>{error.general}</p>
              )}

              {/* Success Message */}
              {saveSuccess && (
                <div style={{
                  padding: '12px 16px',
                  backgroundColor: '#d1fae5',
                  color: '#065f46',
                  borderRadius: '4px',
                  marginTop: '16px',
                  fontSize: '14px'
                }}>
                  ✓ Settings saved successfully
                </div>
              )}

              {/* Save Button */}
              <div className={styles.saveButtons}>
                <button
                  className={styles.saveButton}
                  onClick={handleSave}
                  disabled={isLoading}
                  style={{ marginTop: '24px' }}
                >
                  {isLoading ? (
                    <div className='ringLoader'></div>
                  ) :
                    'Save Changes'
                  }
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  )
}

export default Tool
